import { render } from "./CourseView.vue?vue&type=template&id=03bf2419&scoped=true&ts=true"
import script from "./CourseView.vue?vue&type=script&lang=ts"
export * from "./CourseView.vue?vue&type=script&lang=ts"

import "./CourseView.vue?vue&type=style&index=0&id=03bf2419&lang=scss&scoped=true"
import "./CourseView.vue?vue&type=style&index=1&id=03bf2419&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bf2419"]])

export default __exports__